<template>
    <div>
        <!-- Session form -->
        
        <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="learningUnitsEndpoint" 
            :props="props" :titles="titles" :form="form" :bus="bus" icons="1" v-if="form.section_id">

            <trax-ui-select icon="filter_center_focus" :placeholder="lang.polaris.form.type"
                v-model="form.type" :error="errors.type" :options="typeCodeSelect" 
                :disabled="form.id" required="1" v-if="typeCodeSelect">
            </trax-ui-select>

            <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.code"
                v-model="form.code" :error="errors.code" required="1" maxlength="8">
            </trax-ui-input>
            
            <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
                v-model="form.name" :error="errors.name" required="1">
            </trax-ui-input>
            
            <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.description" 
                v-model="form.description" :error="errors.description" :rows="3" v-if="withDescription">
            </trax-ui-input>

            <trax-ui-checkbox :text="lang.polaris.common.progress_check" v-model="form.meta.assessment" 
                v-if="progressCheck">
            </trax-ui-checkbox>

            <trax-ui-checkbox :text="lang.polaris.common.remedial" v-model="form.meta.remedial"
                v-if="registrationId">
            </trax-ui-checkbox>

            <trax-ui-checkbox :text="lang.polaris.common.optional" v-model="form.meta.optional">
            </trax-ui-checkbox>

            <trax-ui-input type="number" step="any" icon="av_timer" :placeholder="lang.polaris.common.theoretical_time"
                v-model="form.meta.duration" :error="errors['meta.duration']" maxlength="5" 
                :help="lang.polaris.dashboard.flight_time_help"
                mark-required="1" v-if="flight">
            </trax-ui-input>
            
            <trax-ui-select icon="flight" :placeholder="lang.polaris.common.aircraft_type"
                v-model="form.meta.aircraft_type" :error="errors['meta.aircraft_type']" :options="aircraft_types_select" 
                required="1" v-if="flight">
            </trax-ui-select>

            <trax-ui-select icon="flight" :placeholder="lang.polaris.common.aircraft_category"
                v-model="form.meta.aircraft_category" :error="errors['meta.aircraft_category']" :options="aircraft_categories_select" 
                required="1" v-if="flight">
            </trax-ui-select>

            <trax-ui-select icon="people" :placeholder="lang.polaris.common.crew_type"
                v-model="form.meta.crew_type" :error="errors['meta.crew_type']" :options="crew_types_select" 
                required="1" v-if="flight">
            </trax-ui-select>

            <trax-ui-select icon="network_check" :placeholder="lang.polaris.common.flight_mode"
                v-model="form.meta.flight_mode" :error="errors['meta.flight_mode']" :options="flight_modes_select" 
                required="1" v-if="flight">
            </trax-ui-select>

            <trax-ui-select icon="brightness_medium" :placeholder="lang.polaris.common.flight_conditions"
                v-model="form.meta.flight_conditions" :error="errors['meta.flight_conditions']" :options="flight_conditions_select" 
                required="1" v-if="flightOnly">
            </trax-ui-select>

            <trax-ui-select icon="gps_fixed" :placeholder="lang.polaris.common.flight_objective"
                v-model="form.meta.flight_objective" :error="errors['meta.flight_objective']" :options="flight_objectives_select" 
                required="1" v-if="flight">
            </trax-ui-select>

            <trax-ui-select icon="list" :placeholder="lang.polaris.common.flight_session_serie"
                v-model="form.meta.flight_session_serie" :error="errors['meta.flight_session_serie']" :options="flight_session_series_select" 
                :unselected="lang.polaris.common.flight_session_serie_no" v-if="flight">
            </trax-ui-select>

            <trax-ui-select icon="playlist_add_check" :placeholder="lang.polaris.training.competencies"
                v-model="form.meta.competencies" :error="errors['meta.competencies']" :options="competency_domains_select"
                multiple="1" v-if="flight || levelReport">
            </trax-ui-select>

            <trax-ui-checkbox :text="lang.polaris.common.flight_mcc" v-model="form.meta.flight_mcc" 
                v-if="flight">
            </trax-ui-checkbox>

        </trax-ui-ajax-form-in-modal>

        <!-- Section form -->

        <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
            :props="props" :titles="titles" :form="form" :bus="bus" icons="1" v-if="!form.section_id">

            <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
                v-model="form.name" :error="errors.name" required="1">
            </trax-ui-input>
        </trax-ui-ajax-form-in-modal>
    </div>
</template>

<script>
    export default {

        props: {
            id: null,
            toastrId: null,
            endpoint: null,
            learningUnitsEndpoint: null,
            typeCodeSelect: null,
            indexId: null,
            registrationId: null,
            withDescription: null,
            bus: null
        },
    
        data: function() {
            var props = {
                id: { source:'id' },
                section_id: { source:'section_id' },
                type: { source:'type' },
                program_id: { source:'program_id', default: this.indexId },
                user_id: { source:'user_id' },
                registration_id: { source:'registration_id' },
                order: { source:'order' },
                name: { source:'name' },
                code: { source:'code' },
                meta: { source: this.meta },
            };
            if (this.withDescription) props.description = { source:'description' };
            return {
                lang: lang,
                form: {
                    meta: {}
                },
                errors: {},
                props: props,
                aircraft_types_select: data.aircraft_types_select,
                aircraft_categories_select: data.aircraft_categories_select,
                crew_types_select: data.crew_types_select,
                flight_modes_select: data.flight_modes_select,
                flight_conditions_select: data.flight_conditions_select,
                flight_objectives_select: data.flight_objectives_select,
                flight_session_series_select: data.flight_session_series_select,
                competency_domains_select: data.competency_domains_select,
                titles: {
                    new: lang.polaris.form.new_item,
                    update: lang.polaris.form.item_update
                },
                data: {
                    section_id: null
                },
            }
        },

        computed: {

            type: function() {
                return this.form.type;
            },

            progressCheck: function() {
                return (this.type == 'enac-atpl-course-session'
                    || this.type == 'enac-atpl-simu-session'
                    || this.type == 'enac-atpl-flight-session'
                );
            },

            flight: function() {
                return (this.type == 'enac-atpl-simu-session'
                    || this.type == 'enac-atpl-flight-session'
                );
            },

            flightOnly: function() {
                return this.type == 'enac-atpl-flight-session';
            },

            levelReport: function() {
                return this.type == 'enac-atpl-level-report';
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(this.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(this.id+'-data', function(data) {
                that.form = data;
            });
        },

        methods: {
            
            meta(data) {
                return Array.isArray(data.meta) ? {} : data.meta
            }
        }
    }
</script>
